'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var button = require('./button.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var parts = ['container', 'switch', 'separator'];
var baseStyleContainer = function baseStyleContainer(props) {
  var isFitted = props.isFitted;
  return {
    display: isFitted ? 'flex' : 'inline-flex',
    flexDirection: 'row'
  };
};
var baseStyleSwitch = function baseStyleSwitch(props) {
  var sizeProp = props.size,
    isFitted = props.isFitted;
  var buttonProps = props;
  var baseStyle = button["default"].baseStyle(buttonProps);
  var outline = button["default"].variants.outline(buttonProps);
  var solid = button["default"].variants.solid(buttonProps);
  var size = button["default"].sizes[sizeProp];
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, baseStyle), outline), size), {}, {
    borderRadius: 'base',
    flexGrow: isFitted ? 1 : 0,
    _selected: _objectSpread(_objectSpread({}, solid), {}, {
      // To prevent the button from "jumping" in size when selecting,
      // we reduce the usual border width to 1px.
      borderWidth: '1px',
      // To make the focused shadow show above other buttons,
      // we increase the z-index.
      zIndex: 1
    })
  });
};
var baseStyleSeparator = function baseStyleSeparator(props) {
  var c = props.colorScheme;
  return {
    display: 'inline-block',
    width: '1px',
    backgroundColor: "".concat(c, ".400"),
    boxShadow: 'md'
  };
};
var baseStyle = function baseStyle(props) {
  return {
    container: baseStyleContainer(props),
    "switch": baseStyleSwitch(props),
    separator: baseStyleSeparator(props)
  };
};
var defaultProps = {
  size: 'md',
  colorScheme: 'blue'
};
var sizes = {
  xs: {
    "switch": {
      py: 2.5,
      px: 2,
      fontSize: 'sm'
    }
  },
  sm: {
    "switch": button["default"].sizes.sm
  },
  md: {
    "switch": button["default"].sizes.md
  }
};
var ContentSwitcher = {
  parts: parts,
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: defaultProps
};
exports["default"] = ContentSwitcher;